import { css } from '@emotion/react';

export const icon = css({
  width: '72px',
  height: '72px',
  margin: '8px'
});
